
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "reactiveweb/-embroider-implicit-modules.js";
import "ember-modify-based-class-resource/-embroider-implicit-modules.js";
import "@cardstack/boxel-icons/-embroider-implicit-modules.js";
import "@cardstack/boxel-ui/-embroider-implicit-modules.js";
import "@ember/test-waiters/-embroider-implicit-modules.js";
import "@glimmer/component/-embroider-implicit-modules.js";
import "@universal-ember/test-support/-embroider-implicit-modules.js";
import "ember-async-data/-embroider-implicit-modules.js";
import "ember-basic-dropdown/-embroider-implicit-modules.js";
import "ember-cli-babel/-embroider-implicit-modules.js";
import "ember-click-outside/-embroider-implicit-modules.js";
import "ember-concurrency/-embroider-implicit-modules.js";
import "ember-css-url/-embroider-implicit-modules.js";
import "ember-focus-trap/-embroider-implicit-modules.js";
import "ember-keyboard/-embroider-implicit-modules.js";
import "ember-lifeline/-embroider-implicit-modules.js";
import "ember-modifier/-embroider-implicit-modules.js";
import "ember-moment/-embroider-implicit-modules.js";
import "ember-page-title/-embroider-implicit-modules.js";
import "ember-provide-consume-context/-embroider-implicit-modules.js";
import "ember-qunit/-embroider-implicit-modules.js";
import "ember-resources/-embroider-implicit-modules.js";
import "ember-route-template/-embroider-implicit-modules.js";
import "ember-velcro/-embroider-implicit-modules.js";
import "ember-window-mock/-embroider-implicit-modules.js";
import "tracked-built-ins/-embroider-implicit-modules.js";
import "ember-cli-inject-live-reload/-embroider-implicit-modules.js";
import "ember-cli-fastboot/-embroider-implicit-modules.js";
import "development-cors-middleware/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
import "@ember/string/-embroider-implicit-modules.js";
import "@glimmer/tracking/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-freestyle/-embroider-implicit-modules.js";
import "ember-load-initializers/-embroider-implicit-modules.js";
import "@ember/optional-features/-embroider-implicit-modules.js";
import "@ember/test-helpers/-embroider-implicit-modules.js";
import "ember-template-imports/-embroider-implicit-modules.js";
import "@percy/ember/-embroider-implicit-modules.js";
import "ember-cli-app-version/-embroider-implicit-modules.js";
import "ember-cli-clean-css/-embroider-implicit-modules.js";
import "ember-cli-dependency-checker/-embroider-implicit-modules.js";
import "ember-cli-deploy/-embroider-implicit-modules.js";
import "ember-cli-deploy-cloudfront/-embroider-implicit-modules.js";
import "ember-cli-deploy-build/-embroider-implicit-modules.js";
import "ember-cli-deploy-revision-data/-embroider-implicit-modules.js";
import "ember-cli-deploy-fastboot-s3/-embroider-implicit-modules.js";
import "ember-cli-deploy-s3/-embroider-implicit-modules.js";
import "ember-cli-deploy-smart-compress/-embroider-implicit-modules.js";
import "ember-test-selectors/-embroider-implicit-modules.js";
import "ember-cli-deprecation-workflow/-embroider-implicit-modules.js";
import "broccoli-asset-rev/-embroider-implicit-modules.js";
import "ember-cli-terser/-embroider-implicit-modules.js";
import "ember-cli-sri/-embroider-implicit-modules.js";
import "ember-source/-embroider-implicit-modules.js";
import "ember-cli-typescript-blueprints/-embroider-implicit-modules.js";
import "ember-elsewhere/-embroider-implicit-modules.js";
import "ember-exam/-embroider-implicit-modules.js";
import "ember-resolver/-embroider-implicit-modules.js";
import "loader.js/-embroider-implicit-modules.js";
import "setup-ast-transforms/-embroider-implicit-modules.js";
